import { FormControlLabel, Radio } from '@mui/material';
import { useFormContext } from 'framework/form';
import type { SourcingFilterKey } from '../../../types';

type Props = {
  filterKey: SourcingFilterKey;
  disabled?: boolean;
};

const StrictFilterToggle = ({ filterKey, disabled = false }: Props) => {
  const { data, onChangeCallback } = useFormContext();
  const stricts = Array.isArray(data?.stricts)
    ? data.stricts.filter((key): key is SourcingFilterKey => typeof key === 'string')
    : [];
  const checked = disabled || stricts.includes(filterKey);

  return (
    <FormControlLabel
      control={
        <Radio
          checked={checked}
          onChange={() =>
            onChangeCallback?.({
              stricts: [...stricts, filterKey],
            })
          }
          onClick={() => {
            if (checked && !disabled) {
              onChangeCallback?.({
                stricts: stricts.filter(key => key !== filterKey),
              });
            }
          }}
          disabled={disabled}
        />
      }
      label="Strict filter"
      sx={{
        m: 0,
        height: 20,
        '& svg': { fontSize: 20 },
        '& .MuiRadio-root': { p: 0, fontSize: 12 },
        '& .MuiTypography-root': { ml: 0.75, fontSize: 12, color: 'text.secondary' },
      }}
    />
  );
};

export default StrictFilterToggle;
